import { WHATSNEWDATA } from '../../constants/reducerTypes';

const initialState = [];
const whatsNewReducer = (state = initialState, action) => {
  switch (action.type) {
    case WHATSNEWDATA:
      return action.payload;
    default:
      return state;
  }
};
export default whatsNewReducer;
